import { render, staticRenderFns } from "./loading.init.vue?vue&type=template&id=f3051812&scoped=true&"
import script from "./loading.init.vue?vue&type=script&lang=js&"
export * from "./loading.init.vue?vue&type=script&lang=js&"
import style0 from "./loading.init.vue?vue&type=style&index=0&id=f3051812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3051812",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
